<template>
  <b-container v-if="item">
    <b-card>
      <b-form @submit.stop.prevent="edit_item">

        <b-form-group label="Name:" invalid-feedback="Must be greater then 4 character" description="Name of the site">
          <b-form-input v-model="item.name" required placeholder="Enter name" :state="validate_state('name')" @change="edit_item"></b-form-input>
        </b-form-group>
      </b-form>
    </b-card>

    <b-card class="mt-4" bg-variant="danger" header="Delete site" text-variant="white">
      <p class="text-white">Delete your site and cancel your subscription</p>
      <b-button size="sm" @click="delete_item">Delete</b-button>
    </b-card>
  </b-container>
  <!-- <b-container class="card py-4" >


    <hr>

  </b-container> -->
</template>

<script>
import { db } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"

export default {
  name: 'site_edit',
  mixins: [ItemMixin],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.site_id)
    }
  },
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  data() {
    return {
      item: undefined,
      is_saving: false,
      collection: 'site'
    }
  },
  metaInfo() {
    return {
      title: `${this.collection} edit`
    };
  },
}
</script>

<style scoped>

</style>
